<template>
  <v-app :style="this.$vuetify.theme.dark ? '' : 'background-color: #EEE'">
    
    <div class="mainContent">
      <v-main>
        <v-container class="pa-0 mainContent" fluid>
          <vue-page-transition name="fade">
            <!-- <Login v-if="!isLoggedIn" /> -->
            <router-view />
          </vue-page-transition>
          <vue-progress-bar></vue-progress-bar>
        </v-container>
      </v-main>
    </div>

    <v-dialog max-width="400" v-model="infoDialog">
      <v-card dir="ltr">
        <v-card-title>University CMS</v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          Developed and designed by: <b>Ahmad Faris</b>
          <br />
          Dijla University: IT Section
          <br />
          <br />
          version: {{ $appVersion }}
          <br />
          Send your feedback to:
          <b><a href="mailto:it.head@duc.edu.iq">it.head@duc.edu.iq</a></b>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
// import Logo from "./components/Logo.vue";
export default {
  name: "App",
  components: {
    // Logo,
  },
  data: () => ({
    drawer: false,
    items: [],
    infoDialog: false,
  }),
  methods: {
    logout() {
      localStorage.clear();
      this.$router.push("/securedAuth");
      setTimeout(() => {
        location.reload();
      }, 1000);
    },
    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("darkMode", this.$vuetify.theme.dark);
    },
    launchDrawer() {
      this.drawer = !this.drawer;
      localStorage.setItem("drawer", this.drawer);
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userInfo() {
      return this.$store.getters.getLoginInfo;
    },
  },
  mounted: function () {
    this.$Progress.finish();
  },
  created: function () {
    this.$Progress.start();

    let isDarkMode = false;
    if (localStorage.getItem("darkMode") == "true") {
      isDarkMode = true;
    }
    if (localStorage.getItem("drawer") == "true") {
      this.drawer = true;
    }
    this.$vuetify.theme.dark = isDarkMode;
    if (this.userInfo != null) {
      this.items = [
        {
          title: this.$t("home"),
          icon: "las la-home",
          route: "/" + this.userInfo.sectionSlug,
          role: "All",
        },
        {
          title: "معلومات القسم",
          icon: "la-user-circle",
          route:
            "/" +
            this.userInfo.sectionSlug +
            "/securedAuth/section/" +
            this.userInfo.sectionId,
          role: "Website Editor",
        },
        {
          title: "القوائم",
          icon: "la-file-alt",
          route: "/" + this.userInfo.sectionSlug + "/securedAuth/menu/",
          role: "Website Editor",
        },
        {
          title: "الكادر",
          icon: "la-chalkboard-teacher",
          route: "/" + this.userInfo.sectionSlug + "/securedAuth/staff",
          role: "Website Editor",
        },
        {
          title: "المواد الدراسية",
          icon: "la-book",
          route: "/" + this.userInfo.sectionSlug + "/securedAuth/lessons",
          role: "Website Editor",
        },
        {
          title: "الصفحات",
          icon: "la-file",
          route: "/" + this.userInfo.sectionSlug + "/securedAuth/pages",
          role: "Website Editor",
        },
        {
          title: "اخبار القسم",
          icon: "la-newspaper",
          route: "/" + this.userInfo.sectionSlug + "/securedAuth/posts",
          role: "Website Editor",
        },
        {
          title: "معرض الصور",
          icon: "la-photo-video",
          route: "/" + this.userInfo.sectionSlug + "/securedAuth/gallery",
          role: "Website Editor",
        },
        {
          title: "الاقسام",
          icon: "la-icons",
          route: "/admin/securedAuth/sections",
          role: "Admin",
        },
        {
          title: "الملفات",
          icon: "la-file",
          route: "/" + this.userInfo.sectionSlug + "/securedAuth/uploads",
          role: "Admin",
        },
        {
          title: "المستخدمين",
          icon: "la-user",
          route: "/admin/securedAuth/users",
          role: "Admin",
        },
        {
          title: "الطلاب",
          icon: "la-users",
          route: "/admin/securedAuth/students",
          role: "Admin",
        },
      ];
    }
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish(to, from);
    });
  },
};
</script>

<style src="./style.css"></style>